import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";

export const MODULE = "OTP";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $send = ActionCreator.Async(MODULE, "Send", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/otp/send`, payload)
      .then((response) => {
        dispatch($send.success(response));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $resend = ActionCreator.Async(MODULE, "Resend", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/otp/resend`, payload)
      .then((response) => {
        dispatch($resend.success(response));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});
